<template>
  <div class="container" id="contenedor-principal">
    <!-- -->
    <div class="row">
      <div class="col-5">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              <i class="fas fa-search"></i>
            </span>
          </div>
          <input
            v-model="search"
            type="text"
            class="form-control"
            placeholder="buscar"
            aria-label="Username"
            aria-describedby="basic-addon1"
          />
        </div>
        <div class="list-group" id="lista-empleados" :style="style_list">
          <a
            v-for="(e, i) in empleados_filter"
            class="list-group-item list-group-item-action"
            style="padding:2px 10px"
            @click="activar(i)"
            :class="{ active: i == active }"
            :key="e.nombre"
          >
            <span class="badge badge-dark">{{ e.id }}</span>
            {{ e.nombre }}
          </a>
        </div>
      </div>
      <div class="col-7">
        <div class="content">
          <h3 class="title">Datos del nuevo repartidor</h3>
          <!-- form -->
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
            v-if="agregado"
          >
            <strong>Se agrego el repartidor:</strong> es importante que copie el
            PIN de acceso del usuario.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- Email -->
          <div class="form-group">
            <label for="email">
              Empleado ID: <i class="fas fa-asterisk"></i>
            </label>
            <input
              type="number"
              v-model="form.empleado_id"
              class="form-control"
              id="empleado_id"
              readonly
            />
            <span class="text-danger" v-if="errors.email">
              {{ errors.empleado_id[0] }}
            </span>
          </div>
          <!-- Email -->
          <div class="form-group">
            <label for="email">
              Correo Electronico: <i class="fas fa-asterisk"></i>
            </label>
            <input
              type="email"
              v-model="form.email"
              class="form-control"
              id="email"
              :readonly="agregado"
            />
            <span class="text-danger" v-if="errors.email">
              {{ errors.email[0] }}
            </span>
          </div>
          <!-- Telefono -->
          <div class="form-group">
            <label for="telefono">
              Número Telefonico: <i class="fas fa-asterisk"></i>
              <small>(diez digitos)</small>
            </label>
            <input
              type="number"
              v-model="form.telefono"
              class="form-control"
              id="telefono"
              :readonly="agregado"
            />
            <span class="text-danger" v-if="errors.telefono">
              {{ errors.telefono[0] }}
            </span>
          </div>
          <!-- Telefono -->
          <div class="form-group" v-if="agregado">
            <label for="pin">
              PIN de acceso:
              <small>(Necesario para que pueda acceder)</small>
            </label>
            <input
              type="number"
              v-model="form.password"
              class="form-control"
              id="pin"
              readonly
              @click="copiarContent"
            />
            <span class="text-danger" v-if="errors.pin">
              {{ errors.telefono[0] }}
            </span>
          </div>

          <router-link
            class="btn btn-lg btn-block btn-dark"
            :to="{ name: 'Repartidores' }"
            v-if="agregado"
          >
            <i class="fas fa-hand-point-left"></i> Regresar
          </router-link>
          <button
            v-else
            :disabled="form_incompleto"
            class="btn btn-lg btn-block btn-primary"
            :class="{ 'btn-secondary': form_incompleto }"
            @click="agregar_repartidor"
          >
            <i class="fas fa-plus"></i> Agregar Repartidor
          </button>
          <!-- form -->
        </div>
      </div>
    </div>
    <!-- -->
  </div>
</template>

<style lang="scss"></style>

<script>
import User from "../../apis/User";

export default {
  data() {
    return {
      active: -1,
      style_list: "height: 300px",
      search: "",
      agregado: false,
      form: {
        empleado_id: "",
        email: "",
        telefono: "",
        password: ""
      },
      errors: {
        name: null,
        email: null,
        telefono: null
      },
      empleados: []
    };
  },
  created() {
    User.empleados_repartidores().then(data => {
      this.empleados = data.data;
    });
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.resize);
      this.resize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize: function() {
      let barra = document.getElementById("barra-superior");
      if (barra == null) {
        return (this.style_list = "height: 300px");
      }
      let btop = document.getElementById("barra-superior").offsetHeight + 90;
      let h = window.innerHeight - btop;
      this.style_list = `height: ${h}px`;
    }, // resize
    activar: function(index) {
      if (this.active == index) {
        this.active = -1;
        return (this.form.empleado_id = "");
      }
      this.active = index;
      this.form.empleado_id = this.empleados_filter[index].id;
    },
    agregar_repartidor: function() {
      User.agregar_repartidor(this.form).then(response => {
        this.form.password = response.data.pin;
        this.agregado = true;
        this.$nextTick(function() {
          document.getElementById("pin").select();
          document.execCommand("copy");
        });
      });
    },
    copiarContent: function(event) {
      event.target.select();
      document.execCommand("copy");
    }
  }, // end methods
  computed: {
    empleados_filter: function() {
      if (this.search == "") {
        return this.empleados;
      }
      return this.empleados.filter(
        e => e.nombre.toLowerCase().indexOf(this.search.toLowerCase()) != -1
      );
    },
    // regresa true si el formulario no esta terminado
    form_incompleto: function() {
      if (parseInt(this.form.empleado_id) <= 0) {
        return true;
      }
      let reMail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (!this.form.email || !reMail.test(this.form.email)) {
        return true;
      }
      if (!this.form.telefono || this.form.telefono.length != 10) {
        return true;
      }
      return false;
    }
  } // computed
};
</script>

<style scoped>
.col-4 {
  border-right: 2px solid #eee;
}
.col-8 {
  background: #eee;
  border-left: 2px solid #ccc;
  box-shadow: 2px 2px 15px #e0e0e0 inset, -2px -2px 15px #e0e0e0 inset;
}

#lista-empleados {
  cursor: pointer;
  background: #ddd;
  position: relative;
  overflow-y: scroll;
  box-shadow: 1px 2px 0 #ccc;
}
.title {
  text-align: center;
  color: #777;
  text-shadow: -1px -1px 1px rgba(255, 255, 255, 0.8);
  font-weight: 500;
  border-bottom: 2px solid #ddd;
  box-shadow: 0 -2px 0 rgba(255, 255, 255, 0.5) inset;
}
</style>
